/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponsePayMthdInfo
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponsePayMthdInfo {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponsePayMthdInfo
     */
    benepoUseFlag?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponsePayMthdInfoFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponsePayMthdInfo {
    return JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponsePayMthdInfoFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponsePayMthdInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponsePayMthdInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'benepoUseFlag': !exists(json, 'benepoUseFlag') ? undefined : json['benepoUseFlag'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponsePayMthdInfoToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponsePayMthdInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'benepoUseFlag': value.benepoUseFlag,
    };
}

